import { vec3 } from 'gl-matrix'
import gsap from 'gsap'

import { HexToNewVec3, Vec3ToHex } from '@/webgl/core/Color'

type Color = {
  r: number
  g: number
  b: number
}

export default class ColorTransition {
  _current: Color
  _vecValue: vec3
  _hexValue: number

  get Color() {
    return this._current
  }

  get Vec3() {
    return this._vecValue
  }

  get Hex() {
    return this._hexValue
  }

  constructor(readonly source: number = 0x000000) {
    this._vecValue = HexToNewVec3(source)
    this._current = {
      r: this._vecValue[0],
      g: this._vecValue[1],
      b: this._vecValue[2],
    }
  }

  to(target: number, opts: Partial<gsap.TweenVars>) {
    const targetColor = HexToNewVec3(target)

    const params = {
      ...opts,
      onUpdate: () => {
        this._vecValue[0] = this._current.r
        this._vecValue[1] = this._current.g
        this._vecValue[2] = this._current.b
        this._hexValue = Vec3ToHex(this._vecValue)
        if (opts.onUpdate) opts.onUpdate(this._vecValue)
      },
    }

    gsap.to(this._current, {
      r: targetColor[0],
      g: targetColor[1],
      b: targetColor[2],
      ...params,
    })
  }
}
